"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecommendationBullets = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getRecommendationBullets = (isRothRecommended, withdrawalAge, currentAge, retTaxRate, preference) => {
  var rothHeader = 'Roth (after-tax) contributions may be right for you';
  var traditionalHeader = 'Traditional (pre-tax) contributions may be right for you';
  var header = isRothRecommended ? rothHeader : traditionalHeader;
  var bulletArray = [];
  if (isRothRecommended) {
    // Add all roth related bullets here
    if (withdrawalAge - currentAge > 5) bulletArray.push('You do not intend to withdraw from the account within 5 years of your first contribution');
    if (retTaxRate === 'higher') bulletArray.push('You think your tax rate may be higher in retirement');
    if (preference === 'now') bulletArray.push('You prefer to pay taxes now and allow your savings to grow tax-free');
  } else {
    // Add all traditional related bullets here
    if (withdrawalAge - currentAge <= 5) bulletArray.push('Since you intend to withdraw from the account within 5 years of your first contribution, a traditional plan allows you to avoid penalties');
    if (retTaxRate === 'lower') bulletArray.push('You think your tax rate may be lower in retirement');
    if (preference === 'later') bulletArray.push('You prefer to defer taxes until withdrawals are made');
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("h4", null, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "no-margin-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", null, bulletArray.map((bullet, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, bullet);
  })))));
};
exports.getRecommendationBullets = getRecommendationBullets;